"use client";
import React, { useState } from "react";
import { useEffect } from "react";
import { notFound, useRouter } from "next/navigation";
import styles from "./page.module.scss";
import Image from "next/image";
import { IMAGE_TYPE } from "@/src/const/const";
import iconLocation from "@/public/icon/icon-location-newest.svg";
import iconWebsite from "@/public/icon/icon-website-2.svg";
import iconPhone from "@/public/icon/icon-phone-newest.svg";
import iconWorkTime from "@/public/icon/icon-work-time-new.svg";
import iconWriting from "@/public/icon/icon-writing.svg";
import { formatWorkingDays, toSlug, convertPhoneZero } from "@/src/util/util";
import { Col, Row, Breadcrumb, Modal, Button, Form } from "antd";
import iconAdvise from "@/public/icon/icon-advise-new.svg";
import iconCallPhone from "@/public/icon/icon-call-phone.svg";
import callShortcut from "@/public/icon/icon-call-phone.svg";
import promotionTagIcon from "@/public/icon/promotion-tag-icon.svg";

import iconClose from "@/public/icon/icon-close.png";
import _ from "lodash";
import iconGift from "@/public/icon/icon-gift.png";
import iconCalenda from "@/public/icon/icon-calenda.png";
import { Link as LinkScroll, Element, scroller } from "react-scroll";
import "@/src/style/chi-tiet.css";
import Price from "@/src/component/detail/price";
import Location from "@/src/component/detail/location";
import ImageCommon from "@/src/component/image/image";
import iconRatingStar from "@/public/icon/star.svg";
import IntroduceDetail from "@/src/component/detail/introduce-detail";
import ChatBox from "@/src/component/detail/chatbox";
import Link from "next/link";
import NotFound from "../../not-found/page";
import { createCallLogs } from "./service-server";
import ClinicBlog from "../../../component/detail/clinic-blog";
import getCouponShortcut from "@/public/icon/getCouponShortcut.svg";
import iconZalo from "../../../../public/icon/icon-zalo.svg";
import dynamic from "next/dynamic";
import { getClinicBlog } from "./service";
import tickIcon from "@/public/icon/tick-icon.svg";
const Post = dynamic(() => import("@/src/component/detail/post"));
const Doctor = dynamic(() => import("@/src/component/detail/doctor"));
const Showcase = dynamic(() => import("@/src/component/detail/showcase"));
const Infrastructure = dynamic(
  () => import("@/src/component/detail/infrastructure"),
  { ssr: false }
);
const Review = dynamic(() => import("@/src/component/detail/review"));
const ListClinic = dynamic(() => import("../../tim-nha-khoa/list-clinic"));
const dataMenuSection = [
  { id: "tong-quan", name: "Tổng quan" },
  { id: "bang-gia-dich-vu", name: "Bảng giá dịch vụ" },
  { id: "co-so-vat-chat", name: "Cơ sở vật chất" },
  { id: "doi-ngu-bac-si", name: "Đội ngũ bác sỹ" },
  { id: "tin-tuc", name: "Tin tức" },
  { id: "showcase", name: "Showcase" },
  { id: "danh-gia", name: "Đánh giá" },
  { id: "gioi-thieu", name: "Giới thiệu chi tiết" },
  { id: "vi-tri", name: "Vị trí" },
  {
    id: "cac-nha-khoa-cung-khu-vuc",
    name: "Các nha khoa cùng khu vực",
  },
];
// import StarRatings from "react-star-ratings";
import ItemOverviewRatingNew from "@/src/component/detail/item-overview-rating-new";
import { LoadingOutlined } from "@ant-design/icons";
import { useSession } from "next-auth/react";
import imageCompression from "browser-image-compression";
import axios from "axios";
import btnPromotion from "@/public/image/btn-promotion.webp";
// import tagVoucher from "@/public/image/tag-voucher.png";
import GetCouponModal from "@/src/component/coupon/get-coupon-modal";
import PhoneNumber from "@/src/component/dialog/phone-number";
import { getDataForClinicDetail } from "./service";
import * as NProgress from "nprogress";
import FormChatbot from "../../../component/dialog/form-chat-bot";
import FormChatbotMobile from "../../../component/dialog/form-chat-bot-mobile";
import DirectionsForUseModal from "@/src/component/coupon/directions-for-use";
import iconCall from "@/public/icon/icon-call.svg";

export default function DetailClinicClient({
  detailClinic,
  breadcrumbData,
  // svSession,
}) {
  const router = useRouter();
  // const { service_name, service_slug } = router?.query || {};
  const targetScrollTo = router?.query?.scrollTo;
  if (targetScrollTo) {
    scroller.scrollTo("danh-gia", {
      duration: 1000,
      delay: 100,
      smooth: true,
      offset: 0, // Scrolls to element + 50 pixels down the page
    });
    setTimeout(() => {
      router.query = { scrollTo: null };
    }, 5000);
  }

  if (detailClinic.error === "Not Found") {
    return notFound();
  }

  const date = new Date();
  const validContract = detailClinic?.user?.user_agreements?.length > 0;
  const cover = detailClinic?.image?.find(
    (item) => item.image_type === IMAGE_TYPE.banner
  );
  const logo = detailClinic?.image?.find(
    (item) => item.image_type === IMAGE_TYPE.avatar
  );
  const workday = detailClinic?.workday?.map((item) => {
    return {
      id: item.weekday.id,
      name: item.weekday.name,
    };
  });
  const [openModal, setOpenModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalPhone, setModalPhone] = useState(false);
  const [openModalChatbotMobile, setOpenModalChatbotMobile] = useState(false);
  const [classFormChat, setClassFormChat] = useState("");

  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;
  const isShowBtnZalo = detailClinic.slug.includes(
    "nha-khoa-uc-chau-co-so-nguyen-van-cu-ha-long"
  );
  const [dataForClinicDetail, setDataForClinicDetail] = useState(null);
  const [dataBlog, setDataBlog] = useState(null);
  useEffect(() => {
    if (openModal) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [openModal]);

  useEffect(() => {
    if (isModalOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [isModalOpen]);
  //get url Breadcrumb address
  const provinceSlug = detailClinic?.address[0]?.province?.slug;
  const districtSlug = detailClinic?.address[0]?.district?.slug;
  const wardSlug = detailClinic?.address[0]?.wards?.slug;
  const provinceName = detailClinic?.address[0]?.province?.name;
  const districtName = detailClinic?.address[0]?.district?.name;
  const wardName = detailClinic?.address[0]?.ward?.name;
  const nearbyClinics = detailClinic?.nearbyClinic;

  const debounceScroll = _.debounce((id) => {
    const element_to_scroll_to = document.getElementById(id);
    if (element_to_scroll_to) {
      // element_to_scroll_to.scrollIntoView({
      //   behavior: "smooth",
      // });
      // window.scrollTo(element_to_scroll_to.offsetTop, 0);
      document.getElementById("wp-menu-section").scrollTo({
        left: document.getElementById(id).offsetLeft - 50,
        behavior: "smooth",
      });
    }
  }, 300);

  const openZaloChatbox = () => {
    window.open("https://zalo.me/app/link/xmelgg4mfw");
  };

  useEffect(() => {
    async function fetchData() {
      const params = {
        clinic_id: detailClinic?.id,
        clinic_slug: detailClinic?.slug,
        // longitude: detailClinic?.address[0]?.longitude,
        // latitude: detailClinic?.address[0]?.latitude,
      };
      const [dataForClinicDetail, dataBlog] = await Promise.all([
        getDataForClinicDetail(params),
        getClinicBlog(detailClinic.id) || null,
      ]);
      setDataForClinicDetail(dataForClinicDetail);
      setDataBlog(dataBlog);
    }
    fetchData();
  }, [detailClinic]);

  const dataRatingService = [
    {
      totalRating: detailClinic?.rating_overview?.infrastructure,
      nameService: "Cơ sở vật chất",
    },
    {
      totalRating: detailClinic?.rating_overview?.service_quality,
      nameService: "Chất lượng dịch vụ",
    },
    {
      totalRating: detailClinic?.rating_overview?.procedure,
      nameService: "Quy trình làm việc",
    },
    {
      totalRating: detailClinic?.rating_overview?.doctor,
      nameService: "Đội ngũ bác sỹ",
    },
    {
      totalRating: detailClinic?.rating_overview?.price,
      nameService: "Giá cả hợp lý",
    },
    {
      totalRating: detailClinic?.rating_overview?.care,
      nameService: "Chăm sóc sau điều trị",
    },
  ];
  const targetDate = new Date("2024-09-30T00:00:00.000Z");
  const now = new Date();
  const clinicPhoneNumber =
    detailClinic?.user?.user_agreements &&
    detailClinic?.user?.user_agreements[0]?.status == "ACTIVE" &&
    new Date(detailClinic?.user?.user_agreements[0]?.start_date) <=
      targetDate &&
    new Date(detailClinic?.user?.user_agreements[0]?.end_date) >= now
      ? detailClinic?.phone[0] && detailClinic?.phone[0]?.phone_number
        ? convertPhoneZero(detailClinic?.phone[0]?.phone_number)
        : "_"
      : "0869554535";

  const saveDataCall = async () => {
    const userAgent = navigator?.userAgent;
    const params = {
      clinic_id: detailClinic.id,
      to_phone_number: clinicPhoneNumber,
      clinic_name: detailClinic.name,
      clinic_slug: detailClinic.slug,
      clinic_address: detailClinic?.address[0]?.detail_address,
      landing_page_url: localStorage?.getItem("firstVisitPage")
        ? localStorage?.getItem("firstVisitPage")
        : window?.location?.href,
      referrer: localStorage?.getItem("referrer")
        ? localStorage?.getItem("referrer")
        : "",
      user_agent: userAgent,
    };

    await createCallLogs(params);
  };
  const throttledHandleCallPhone = _.throttle(saveDataCall, 10000, {
    leading: true,
    trailing: false,
  });
  const handleCallPhone = async () => {
    window.open(`tel:${clinicPhoneNumber}`, "_self");
  };

  const [openCouponModal, setOpenCouponModal] = useState(false);
  const [formWriteReview] = Form.useForm();
  return (
    <div className={`${styles.wpDetailClinicDetail} detailClinicContainer`}>
      <div className={styles.nav}>
        <Breadcrumb>
          {breadcrumbData.map((item, index) => {
            return (
              <Breadcrumb.Item key={index}>
                <Link href={item.path}>{item.label}</Link>
              </Breadcrumb.Item>
            );
          })}
        </Breadcrumb>
      </div>
      <div className={styles.wpSectionCover}>
        <div className={styles.wpCover}>
          <ImageCommon
            data={cover}
            style={styles.cover}
            priority={true}
            alt={`Ảnh bìa ${detailClinic?.name}`}
          />
        </div>
        <div className={styles.wpLineCard}>
          <div className={styles.wpCardInfo}>
            <div className={styles.wpCardAbove}>
              <div className={styles.wpCardLeft}>
                <div className={styles.wpClinicAvatar}>
                  <ImageCommon
                    data={logo}
                    style={styles.logo}
                    priority={true}
                    alt={`Logo ${detailClinic?.name}`}
                  />
                </div>
              </div>
              <div className={styles.wpCardRight}>
                <h1 className={styles.clinicName}>{detailClinic?.name}</h1>
                <div className={styles.wpAddress}>
                  <Image
                    src={iconLocation}
                    className={styles.iconLocation}
                    priority={true}
                    alt="Location icon"
                  />
                  <div>{detailClinic?.address[0]?.detail_address}</div>
                </div>
                <Row className={styles.wpLastLine} gutter={16}>
                  <Col xl={14}>
                    <div className={styles.wpRatingLine}>
                      {detailClinic?.rating_overview?.overall_average ? (
                        <div className={styles.wpPoint}>
                          <div className={styles.ratingPoint}>
                            <div className={styles.point}>
                              {detailClinic?.rating_overview?.overall_average
                                ? detailClinic?.rating_overview.overall_average.toFixed(
                                    1
                                  )
                                : 0.0}
                            </div>
                            <Image
                              className={styles.iconRatingStar}
                              src={iconRatingStar}
                              alt="icon rating start"
                              priority={true}
                            />
                          </div>
                          <div className={styles.dash}></div>
                        </div>
                      ) : (
                        <div style={{ width: 5 }}></div>
                      )}
                      <div className={styles.wpCount}>
                        <div className={styles.ratingQuantity}>
                          <span className={styles.ratingQuantityBold}>
                            {detailClinic?.rating_overview?.number_of_ratings
                              ? detailClinic?.rating_overview.number_of_ratings
                              : 0}
                          </span>
                          Đánh giá
                        </div>
                        <div className={styles.dash}></div>
                        <div className={styles.numberOfConsultation}>
                          <span className={styles.numberOfConsultationBold}>
                            {detailClinic?.total_contact}
                          </span>
                          Người đặt lịch
                        </div>
                      </div>
                    </div>
                    <div className={styles.wpTime}>
                      <Image
                        src={iconWorkTime}
                        className={styles.iconWorkTime}
                        alt="Work time icon"
                        priority={true}
                      />
                      {/* <div className={styles.titleScale}>Thời gian làm việc:</div> */}
                      {detailClinic?.time_note ? (
                        <div className={styles.valueScale}>
                          <b>Thời gian làm việc:&nbsp;</b>
                          {detailClinic?.time_note}
                        </div>
                      ) : (
                        <div className={styles.valueScale}>
                          <b>Thời gian làm việc:&nbsp;</b>
                          {detailClinic?.time_start} - {detailClinic?.time_end},{" "}
                          {workday?.length > 0
                            ? formatWorkingDays(workday)
                            : ""}
                        </div>
                      )}
                    </div>
                    {detailClinic?.phone[0] && (
                      <div className={styles.wpScale}>
                        <Image
                          src={iconPhone}
                          className={styles.iconScale}
                          alt="Phone icon"
                          priority={true}
                        />
                        <div className={styles.titleScale}>Liên hệ:</div>
                        <div className={styles.valueScale}>
                          {clinicPhoneNumber}
                        </div>
                      </div>
                    )}
                    {detailClinic?.website &&
                      detailClinic?.user?.user_agreements &&
                      detailClinic?.user?.user_agreements.find(
                        (item) => item.status === "ACTIVE"
                      ) && (
                        <div className={styles.wpScale}>
                          <Image
                            src={iconWebsite}
                            className={styles.iconScale2}
                            alt="Website icon"
                            priority={true}
                          />
                          <div className={styles.titleScale}>Website:</div>
                          <div className={styles.valueScale}>
                            {detailClinic?.website}
                          </div>
                        </div>
                      )}
                    {detailClinic?.promotion_text?.length > 0 &&
                      detailClinic?.promotion_text[0] && (
                        <div className={styles.wpPromotionText}>
                          {detailClinic?.promotion_text[0]
                            ?.split(/\s*[;]\s*/)
                            ?.map((item) => {
                              return (
                                <div className={styles.promotionItem}>
                                  <Image
                                    src={promotionTagIcon}
                                    alt="promotionTagIcon"
                                    width={16}
                                    height={16}
                                    className={styles.promotionTagIcon}
                                  ></Image>
                                  {item}
                                </div>
                              );
                            })}
                        </div>
                      )}
                    {detailClinic?.tag_clinic?.length > 0 && (
                      <div className={styles.wpUtilities}>
                        {detailClinic?.tag_clinic?.map((item) => {
                          return (
                            <div className={styles.utilitiesItem}>
                              <Image
                                src={tickIcon}
                                alt="tickIcon"
                                width={14}
                                height={14}
                                className={styles.tickIcon}
                              ></Image>
                              {item?.tag?.name}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </Col>
                  <Col xl={10} className={styles.wpButton}>
                    {validContract && (
                      <Image
                        src={btnPromotion}
                        className={styles.buttonGetCoupon}
                        onClick={(e) => {
                          e.stopPropagation();
                          setOpenCouponModal(true);
                        }}
                        alt="Get coupon button"
                        priority={true}
                      />
                    )}

                    <div
                      className={`${styles.wpbuttonGetAdvise} button-blue`}
                      onClick={() => {
                        setOpenModal(true);
                      }}
                    >
                      Đặt lịch giữ chỗ
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            <div className={styles.wpCardBelow} onClick={handleCallPhone}>
              <div
                className={styles.wpCallButton}
                id="button-callnow-tracking"
                onClick={throttledHandleCallPhone}
              >
                <Image
                  src={iconCall}
                  className={styles.iconAdvise}
                  width={20}
                  height={20}
                  alt="icon"
                />
                Gọi ngay : {clinicPhoneNumber}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Menu */}
      <div className={`${styles.wpMenu} wp-menu-section`} id="wp-menu-section">
        {dataMenuSection.map((item, index) => {
          switch (item.id) {
            case "doi-ngu-bac-si":
              if (!dataForClinicDetail?.doctor?.length) return null;
              break;
            case "tin-tuc":
              if (!dataForClinicDetail?.post?.total) return null;
              break;
            case "showcase":
              if (!dataForClinicDetail?.showcase?.total) return null;
              break;
            case "danh-gia":
              if (!dataForClinicDetail?.rating?.total) return null;
              break;
            case "cac-nha-khoa-cung-khu-vuc":
              if (!dataForClinicDetail?.nearbyClinic.data) return null;
              break;
          }
          return (
            <LinkScroll
              activeClass="active"
              className="wp-item-menu"
              to={item.id}
              spy={true}
              smooth={true}
              duration={500}
              // offset={0}
              offset={-100}
              ignoreCancelEvents={true}
              onSetActive={() => {
                debounceScroll(item.id);
              }}
            >
              {index !== 2 && (
                <div className="item-menu" id={item.id}>
                  {item.name}
                </div>
              )}
            </LinkScroll>
          );
        })}
      </div>
      {/* section */}
      <div className={styles.wpSection}>
        <div className={styles.wpSectionLeft} id="sectionLeft">
          {/* tong-quan */}
          <div className={styles.wpSectionOverview}>
            <Element name="tong-quan" className="element">
              <div
                className={`${styles.wpOverview} ${styles.wpSectionContainer}`}
              >
                <h2 className={styles.titleSection}>Tổng quan</h2>
                <Row gutter={15}>
                  <Col
                    xs={24}
                    sm={10}
                    md={11}
                    className={styles.colCircleProgress}
                  >
                    <div className={styles.overviewOverall}>
                      Tổng hợp đánh giá từ khách hàng
                    </div>
                    <div className={styles.overviewRating}>
                      <span className={styles.overviewPoint}>
                        {detailClinic?.rating_overview?.overall_average.toFixed(
                          1
                        )}
                      </span>
                      <span className={styles.overviewRangePoint}>/ 5</span>
                    </div>
                    <div
                      className={styles.listOverview}
                      onClick={() => {
                        const getElementReview =
                          document.getElementById("review");
                        if (getElementReview) {
                          getElementReview.scrollIntoView({
                            behavior: "smooth",
                          });
                        }
                      }}
                    >
                      Xem chi tiết đánh giá
                    </div>
                    <div className={styles.writingOverview}>
                      <Image
                        src={iconWriting}
                        className={styles.iconWriting}
                        alt="Writing icon"
                      />
                      <div
                        onClick={() => {
                          NProgress.start();
                          router.push(
                            `/phong-kham/${detailClinic.slug}/danh-gia`
                          );
                        }}
                      >
                        Viết đánh giá
                      </div>
                    </div>
                  </Col>
                  <Col xs={24} sm={14} md={13}>
                    <Row gutter={[10, 10]}>
                      {dataRatingService.map((item, index) => {
                        return (
                          <ItemOverviewRatingNew
                            totalRating={item?.totalRating}
                            className={styles.colStarRating}
                            nameService={item.nameService}
                            key={index}
                          />
                        );
                      })}
                    </Row>
                  </Col>
                </Row>
              </div>
            </Element>
          </div>
          {/* bang-gia-dich-vu */}
          <div>
            <Element name="bang-gia-dich-vu" className="element">
              <div className={styles.wpSectionContainer}>
                <h2 className={styles.titleSection}>Bảng giá dịch vụ</h2>
                {detailClinic.category_service_clinic[0]?.category_service && (
                  <Price detailClinic={detailClinic} />
                )}
                {!detailClinic.category_service_clinic[0]?.category_service && (
                  <div
                    style={{
                      color: "#293568",
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "16px",
                      margin: "12px 0px",
                    }}
                  >
                    Chưa có thông tin
                  </div>
                )}
              </div>
            </Element>
          </div>
          {/* co-so-vat-chat */}
          <Element name="co-so-vat-chat" className="element">
            <div className={styles.wpSectionContainer}>
              <h2 className={styles.titleSection}>Cơ sở vật chất</h2>
              <Infrastructure detailClinic={detailClinic} />
            </div>
          </Element>
          {/* doi-ngu-bac-si */}
          {dataForClinicDetail?.doctor?.length ? (
            <Element name="doi-ngu-bac-si" className="element">
              <div
                className={styles.wpSectionContainer}
                style={
                  isMobile ? { padding: "10px 4px" } : { padding: "24px 18px" }
                }
              >
                <h2 className={styles.titleSection} style={{ marginLeft: 8 }}>
                  Đội ngũ bác sĩ
                </h2>
                <Doctor
                  data={dataForClinicDetail?.doctor}
                  clinic_slug={detailClinic?.slug}
                />
              </div>
            </Element>
          ) : null}

          {/* tin-tuc */}
          {dataForClinicDetail?.post?.total ? (
            <Element name="tin-tuc" className="element">
              <div className={styles.wpSectionContainer}>
                <h2 className={styles.titleSection}>Tin Tức</h2>
                <Post
                  data={dataForClinicDetail?.post?.data}
                  clinic_slug={detailClinic?.slug}
                />
              </div>
            </Element>
          ) : null}

          {/* showcase */}
          {dataForClinicDetail?.showcase?.total ? (
            <Element name="showcase" className="element">
              <div className={styles.wpSectionContainer}>
                <h2 className={styles.titleSection}>Showcase</h2>
                <Showcase
                  showcases={dataForClinicDetail?.showcase}
                  clinic_id={detailClinic?.id}
                />
              </div>
            </Element>
          ) : null}
          {/* danh-gia */}
          <div>
            <Element name="danh-gia" className="element" id="review">
              <div className={styles.wpSectionContainer}>
                <h2 className={styles.titleSection}>Đánh giá</h2>
                <Review
                  dataRatings={dataForClinicDetail?.rating}
                  clinicId={detailClinic?.id}
                  clinicSlug={detailClinic?.slug}
                  overview={detailClinic?.rating_overview}
                />
              </div>
            </Element>
          </div>
          {/*Giới Thiệu Chi Tiết*/}
          <div>
            <Element name="gioi-thieu" className="element">
              <div className={styles.wpSectionContainer}>
                <h2 className={styles.titleSection}>Giới Thiệu Chi Tiết</h2>
                <IntroduceDetail content={detailClinic?.introduce} />
              </div>
            </Element>
          </div>
          {/* vi-tri */}
          <div>
            <Element name="vi-tri" className="element">
              <div className={styles.wpSectionContainer}>
                <h2 className={styles.titleSection}>Vị trí</h2>
                <div className={styles.wpClinicAddress}>
                  <Image
                    src={iconLocation}
                    className={styles.iconAddress}
                    alt="Location icon"
                  ></Image>
                  <div>
                    {detailClinic?.address?.length > 0
                      ? detailClinic?.address[0].detail_address
                      : "_"}
                  </div>
                </div>
                <Location address={detailClinic?.address} />
              </div>
            </Element>
          </div>
          {/* cac-nha-khoa-cung-khu-vuc */}
          {nearbyClinics?.data && (
            <div>
              <Element name="cac-nha-khoa-cung-khu-vuc" className="element">
                <ListClinic data={nearbyClinics?.data} />
              </Element>
            </div>
          )}

          {/* Blog */}
          {dataBlog?.data?.length > 0 && (
            <Element name="blog" className="element">
              <div className={styles.wpSectionContainer}>
                <h2 className={styles.titleSection}>Review nha khoa</h2>
                <ClinicBlog clinicBlogs={dataBlog} />
              </div>
            </Element>
          )}
        </div>
        <div className={styles.wpChat}>
          <Element name="form-lien-he" className="element formChatBox">
            <ChatBox detailClinic={detailClinic} />
          </Element>
        </div>
        <Modal
          className="wpModalChatBox"
          open={openModal}
          onCancel={() => {
            setOpenModal(false);
          }}
          centered
          footer={null}
          closable={true}
          width={380}
          style={{ top: 20 }}
          destroyOnClose={true}
        >
          <div style={{ position: "relative" }}>
            <ChatBox detailClinic={detailClinic} isModal={true} />
            <div
              className="closeModal"
              onClick={() => {
                setOpenModal(false);
              }}
            >
              <Image src={iconClose} alt="Close icon" />
            </div>
          </div>
        </Modal>
      </div>
      {validContract && (
        <div className={styles.wpGift} onClick={() => setOpenCouponModal(true)}>
          <Image
            src={iconGift}
            className={styles.iconGift}
            width={50}
            height={50}
            alt="iconGift"
          />
        </div>
      )}
      <div onClick={handleCallPhone}>
        <div
          className={styles.wpCallPhone}
          id="button-callnow-tracking"
          onClick={throttledHandleCallPhone}
        >
          <div className={styles.circle} />
          <div className={styles.circleFill} />
          <Image
            src={iconCallPhone}
            className={styles.iconCallPhone}
            width={50}
            height={50}
            alt="iconCallPhone"
          />
        </div>
      </div>
      <div className={styles.wpBottomButton}>
        {!isShowBtnZalo && (
          <div
            className={`${styles.wpbuttonGetAdvise} button-blue`}
            onClick={() => {
              // if (classFormChat === "up") return setClassFormChat("down");
              // setClassFormChat("up");
              setOpenModalChatbotMobile(true);
            }}
          >
            <Image
              src={iconAdvise}
              className={styles.iconAdvise}
              alt="Advise icon"
              width={20}
              height={20}
            />
            Nhận tư vấn
          </div>
        )}
        {isShowBtnZalo && (
          <Button
            className={styles.buttonZalo}
            onClick={() => openZaloChatbox()}
          >
            <Image
              src={iconZalo}
              className={styles.iconZalo}
              width={20}
              height={20}
              alt="icon zalo"
            />
            Liên hệ zalo
          </Button>
        )}
        <div
          className={`${styles.wpbuttonGetAdvise} button-blue`}
          onClick={() => {
            setOpenModal(true);
            setClassFormChat("down");
          }}
        >
          <Image
            src={iconCalenda}
            width={20}
            height={20}
            className={styles.iconAdvise}
            alt="Advise icon"
          />
          Đặt lịch giữ chỗ
        </div>
      </div>

      <div className={styles.shortcutButton}>
        {validContract && (
          <Image
            className={styles.shortcutCouponButton}
            src={getCouponShortcut}
            width={66}
            height={66}
            onClick={() => {
              setOpenCouponModal(true);
            }}
            alt="Get coupon button"
          />
        )}

        <div className={styles.animation}>
          <div className={styles.coccocalophcircle}></div>
          <div className={styles.coccocalophcirclefill}></div>
          <a onClick={() => setModalPhone(true)} className={styles.phone}>
            <Image src={callShortcut} alt="iconCall" width={66} height={66} />
          </a>
        </div>
      </div>
      <DirectionsForUseModal
        isModalOpen={openCouponModal}
        setIsModalOpen={setOpenCouponModal}
        detailClinic={detailClinic}
      />
      <PhoneNumber
        openPhoneNumber={modalPhone}
        handleOk={() => setModalPhone(false)}
        handleCancel={() => setModalPhone(false)}
        phoneNumber={clinicPhoneNumber}
      />
      {/* <FormChatbot
        currentPage={"CLINIC_DETAIL"}
        classFormChat={classFormChat}
        closeFormChat={() => {
          setClassFormChat("down");
        }}
      /> */}
      <Modal
        className="modal-chatbot-mobile"
        open={openModalChatbotMobile}
        onCancel={() => {
          setOpenModalChatbotMobile(false);
        }}
        footer={null}
        closable={true}
        width={380}
        destroyOnClose={true}
        centered
      >
        <FormChatbotMobile clinic={detailClinic} />
      </Modal>
    </div>
  );
}
